// import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useParams } from "react-router";
// import { findAssignedLocations } from "../../../store/templateDetail/actions/findAssignedLocations";
// import { findAssignedUsers } from "../../../store/templateDetail/actions/findAssignedUsers";
// import { findUserRoles } from "../../../store/templateDetail/actions/findUserRoles";
import { selectSegmentSelected } from "../../../store/templateDetail/selectors/selectSegmentSelected";
// import { selectTemplateDetail } from "../../../store/templateDetail/selectors/selectTemplateDetail";
// import { AssignSelector } from "./AssignSelector";
import { TemplateFormContainer } from "./TemplateFormContainer";
import { TemplatePreviewContainer } from "./TemplatePreviewContainer";

export const ContentSection = () => {
  const segmentSelected = useSelector(selectSegmentSelected);

  return (
    <>
      {segmentSelected === "preview" && <TemplatePreviewContainer />}
      {segmentSelected === "form" && <TemplateFormContainer />}
    </>
  );
};
